export default __webpack_public_path__ + "static/amstelvar-italic-59f42762b9745c84e2014413ae0ac762.woff2";